import { css } from '@emotion/react';
import React from 'react';

import { SidebarSection } from '@/core/components/layout/SidebarSection.component';
import { useHotel } from '@/hotel';
import { useTheme } from '@/ui/theme';

import { useBooking } from '../hooks';
import CancellationPolicy from './CancellationPolicy.component';
import CancellationPolicyPrePurchaseBody from './CancellationPolicyPrePurchaseBody.component';

interface BookingCancellationPolicySidebarSectionContainerProps {
  bookingId: string;
  hotelSlug: string;
}

export const BookingCancellationPolicySidebarSectionContainer = ({
  bookingId,
  hotelSlug,
}: BookingCancellationPolicySidebarSectionContainerProps) => {
  const booking = useBooking({ bookingId, hotelSlug });
  const hotel = useHotel(hotelSlug);

  const {
    componentProperties: { checkoutSidebar },
  } = useTheme();

  if (!booking || !hotel) return null;

  return (
    <SidebarSection
      css={css({
        ...checkoutSidebar?.cancellationPolicy,
        span: checkoutSidebar?.cancellationPolicy?.description,
      })}
      testId="booking-cancellation-policy-sidebar-section"
    >
      <CancellationPolicy hotelReferenceId={hotel.referenceId}>
        <CancellationPolicyPrePurchaseBody
          hotelReferenceId={hotel.referenceId}
        />
      </CancellationPolicy>
    </SidebarSection>
  );
};

export default BookingCancellationPolicySidebarSectionContainer;
